<template>
  <Card class="tasks-widget">
    <template #default>
      <div class="tasks-widget__title row between baseline">
        <div class="card__title">{{ $tc('task', 2) }}</div>
        <a v-if="showCreate" href="#" @click.prevent="$bus.$emit('task', { reference })">{{ $t('create') }}</a>
      </div>

      <Loader :value="promise" :delay="0" class="tasks-widget__content">
        <div v-if="tasks.length" class="tasks-widget__items">
          <component :is="task.typename" v-for="(task, index) in tasks" :key="index" :value="task" />
        </div>

        <EmptyState v-else :title="$t('noTasks')" :icon="['fal', 'tasks']" class="grow-1 mb-2" />
      </Loader>
    </template>
  </Card>
</template>

<script>
import API from '@/api/Task'
import Card from '@/components/Card'
import CreateTask from '@/components/Task/CreateButton'
import EmptyState from '@/components/EmptyState'
import Types from './Types'

export default {
  props: {
    reference: {
      type: Object,
      required: true,
    },
    showCreate: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    'reference.ref': {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      tasks: [],
      promise: null,
    }
  },
  methods: {
    fetch() {
      this.promise = API.get({ id: this.reference.ref }, { query: `${this.reference.onModel}Tasks` }).then(
        ({ tasks }) => (this.tasks = tasks),
      )

      return this.promise
    },
  },
  created() {
    this.$bus.$on('task:create', this.fetch)
    this.$bus.$on('task:update', this.fetch)
    this.$bus.$on('task:remove', this.fetch)
  },
  beforeDestroy() {
    this.$bus.$off('task:create', this.fetch)
    this.$bus.$off('task:update', this.fetch)
    this.$bus.$off('task:remove', this.fetch)
  },
  components: {
    Card,
    EmptyState,
    CreateTask,
    ...Types,
  },
}
</script>

<style lang="scss">
.tasks-widget {
  overflow: hidden;

  .card__content {
    display: flex;
    flex-direction: column;
    padding: 0;
    flex-grow: 1;
    overflow-y: auto;

    @include scrollShadow();
  }

  .card__title {
    margin-bottom: 0;
  }

  &__title {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: var(--card-spacing);
    background: linear-gradient(to bottom, white 55%, rgba(255, 255, 255, 0));
  }

  &__content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__items {
    padding: 0 var(--card-spacing) var(--card-spacing) var(--card-spacing);
    margin-top: calc(var(--card-spacing) * -0.5);
  }
}
</style>
